import React, { useEffect, useRef } from "react";
import { useState } from "../state/useState";
import { withRouter } from "react-router-dom"

//window.location.reload(true)

window.addEventListener("pageshow", function (event) {
    var historyTraversal = event.persisted ||
        (typeof window.performance != "undefined" &&
            window.performance.navigation.type === 2);
    if (historyTraversal) {
        // Handle page restore.
        window.location.reload();
    }
});


function Component({ match, history }) {

    let [state, dispatch] = useState();
    let formRef = useRef(null);

    // useEffect(() => {
    //     console.log("loading page ", state.redirectTo)
    //     let handle = history.listen(location => {
    //         console.log("location", location)
    //         if (location.action = "POP" && !state.redirectTo) history.replace("/")
    //     })
    //     return handle && handle()
    // }, [])

    // useEffect(() => {
    //     window.location.reload(true)
    // },[])

    useEffect(() => {
        console.log("redirectTo", state.redirectTo)
        if (state.redirectTo == null || state.redirectTo == undefined) {
            history.replace("/")
        }
    })

    useEffect(() => {
        if (formRef.current && state.redirectTo) {
            formRef.current.submit()
        }
    }, [formRef.current, state.redirectTo]);

    let fields = [];
    let encodingStr = ""
    if (state.redirectParams) {
        for (let [key, value] of new Map(Object.entries(state.redirectParams))) {
            console.log("key/value", { key, value });
            fields.push(<input type="hidden" name={key} value={value} />);
        }
        encodingStr = (match.params.encoding == 2 ? "multipart/form-data" : "");
    }


    return <form ref={formRef} action={state.redirectTo} method={state.redirectMethod} enctype={encodingStr}>
        {fields}
    </form>

}

export const Redirect = withRouter(({ history, match }) => <Component history={history} match={match} />);